import useMediaQuery from '@mui/material/useMediaQuery'
import {
  useContentShareState,
  useFeaturedTileState,
  useLocalVideo,
  useRemoteVideoTileState,
} from 'amazon-chime-sdk-component-library-react'

import { collapsedStyles, fluidStyles } from './videoTileGrid.styles'

export type VideoTileGridLayoutMode = 'featured' | 'standard'

export interface VideoTileGridLayout {
  isVideoEnabled: boolean
  isDesktop: boolean
  splitView: boolean
  gridSize: number
  gridLayout: VideoTileGridLayoutMode
  localCss: string
  showPlaceholder: boolean
}

export function useVideoTileGridLayout(layout: VideoTileGridLayoutMode): VideoTileGridLayout {
  const { tileId: contentTileId } = useContentShareState()
  const { tileId: featureTileId } = useFeaturedTileState()
  const { isVideoEnabled } = useLocalVideo()
  const { tiles } = useRemoteVideoTileState()
  const isDesktop = useMediaQuery('(min-width: 768px)')

  const featured = (layout === 'featured' && !!featureTileId) || !!contentTileId
  const remoteSize = tiles.length + (contentTileId ? 1 : 0)
  const splitView = !isDesktop && isVideoEnabled && remoteSize >= 1

  let gridSize: number
  if (splitView) gridSize = 2
  else if (remoteSize > 1 && isVideoEnabled) gridSize = remoteSize + 1
  else gridSize = Math.max(remoteSize, 1)

  let localCss: string
  if (splitView) localCss = fluidStyles
  else if (gridSize > 1 && remoteSize > 0) localCss = fluidStyles
  else localCss = collapsedStyles

  const gridLayout: VideoTileGridLayoutMode = splitView ? 'standard' : featured ? 'featured' : 'standard'
  const showPlaceholder = remoteSize === 0

  return { isVideoEnabled, isDesktop, splitView, gridSize, gridLayout, localCss, showPlaceholder }
}
